<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 30/11/2021
  -->

<template>
	<div :class="[qwoachClasses, ...rootClassesComputed]"
		 v-bind="attrsStylesClass">
		<el-input
			  v-model="valueData"
			  :inputDebounceDelay="inputDebounceDelay"
			  :type="typeComputed"
			  v-bind="attrsVue2"
			  :autosize="multiline ? {minRows} : $attrs.autosize"
			  @input="notifyValueChanged"
			  @blur="onBlur"
			  :prefixIcon="prefixIcon"
			  :class="inputClassesComputed"
			  :readonly="readonly"
			  :disabled="disabled">

<!--			v-bind="{-->
<!--			...attrsVue2,-->
<!--			onInput: notifyValueChanged,-->
<!--			'change:modelValue': notifyValueChanged,-->
<!--			onChange: onChangeEvent,-->
<!--			onBlur: $attrs.onBlur ? $attrs.onBlur : onBlur-->
<!--			}"-->

			<template #append v-if="showEyeIcon || $slots.append">
				<qw-button-icon v-if="showEyeIcon" icon="icon-eye" style="color: inherit"
								@mousedown="setShowPassword(true)"
								@mouseup="setShowPassword(false)"></qw-button-icon>

				<div v-else-if="$slots.append">
					<slot name="append"></slot>
				</div>
			</template>

		</el-input>

	</div>
</template>

<script>

import BaseVModelView from "@/core/components/BaseVModelView.vue";
import {stringToNumber} from "@/utils/helpers";

export default {
	name: "qw-input",
	extends: BaseVModelView,
	inheritAttrs: false,

	props: {
		showDivider: {Boolean, default: true},
		showDividerOnHover: {Boolean, default: false},
		borderDotted: {Boolean, default: false},
		readonly: {Boolean, default: false},
		disabled: {Boolean, default: false},
		inputDebounceDelay: Number,
		multiline: Boolean,
		prefixIcon: String,
		minRows: {Number, default: 1},
		autofocus: Boolean,
		autoSelectOnFocus: Boolean,
		hideBackground: Boolean,
		useQwoachStyle: {Boolean, default: true},
		styleProps: {
			Object, default: () => {
			}
		}
	},


	data() {
		return {
			showEyeIcon: false,
			showPassword: false,
		}
	},

	mounted() {
		if (this.autofocus) {
			this.focus()
		}
	},

	methods: {


		setShowPassword(show) {
			this.showPassword = show
		},

		getInput() {
			return this.$el.getElementsByTagName("input")[0]
		},

		focus() {
			this.getInput().focus()
			if (this.autoSelectOnFocus) {
				setTimeout(() => {
					this.getInput().select()
				})
			}
		},

		selectAll() {
			this.getInput().select()
		},

		onChangeEvent() {
			console.log("QwInput: onChangeEvent: ", this.valueData)
			this.notifyValueChangedImmediate()
			// this.notifyValueChanged()
		},


		formatOutInternal(value) {
			// console.log("BaseVModelView: formatOutInternal: value = ", value)
			if (this.$attrs.type === "number") {
				value = stringToNumber(value)
			}
			if(this.formatDataOutProp){
				value = this.formatDataOutProp(value)
			}
			return value
		},

		setShowEyeIcon(show) {
			this.showEyeIcon = show
		}

	},


	computed: {
		canFocus() {
			let res = !this.readonly && !this.disabled
			// console.log("canFocus = ", res, ", this.readonly = ", this.readonly, ", this.disabled = ", this.disabled)
			return res
		},

		stylePropsStr() {
			return JSON.stringify(this.styleProps).replaceAll('"', "").replaceAll(',', ";")
		},

		typeComputed() {
			this.setShowEyeIcon(false)
			if (this.multiline) {
				return 'textarea'
			}
			if (this.$attrs.type === 'password-show') {
				this.setShowEyeIcon(true)
				if (this.showPassword) {
					return "text"
				}
				return "password"
			}

			return this.$attrs.type
		},

		attrsComputed(){
			let {class: clazz, style, ...restAttrs} = this.$attrs

			let root = {class: clazz, style}
			let inner = restAttrs

			return {root, inner}
		},

		qwoachClasses(){
			return this.useQwoachStyle ? "qw-input-root qw-special qw-input inline-block" : ""
		},

		rootClassesComputed(){
			return [{
				'readonly': this.readonly,
				'input-background': !this.hideBackground && this.useQwoachStyle,
				'input-disabled': this.disabled,
				'input-background-no-padding': this.readonly,
			}]
		},
		inputClassesComputed(){
			return {
				'show-prefix-icon': !!this.prefixIcon,
				'hide-border': !this.borderDotted && (!this.showDivider || !this.canFocus),
				'border-on-hover': this.showDividerOnHover,
				'borderDotted': this.borderDotted,
				'input-secure': this.$attrs.type === 'secure',
			}
		},
	}
}
</script>

<!--@import "../assets/scss/vars";-->

<style lang="scss">

//@import "../../../assets/scss/vars.scss";

.qw-input-root.qw-special.qw-input {

	.inline-block {
		display: inline-block;
	}

	.borderDotted {
		input, textarea {
			border-bottom: 1px dotted $border-color-default !important;
		}
	}

	input, textarea {
		transition: none;
		border-bottom: 1px solid;
		border-radius: 0;
		border-color: $border-color-default;
	}

	input:focus, textarea:focus:not(:read-only) {
		transition: none;
		border-color: $border-color-active;
	}

	.hide-border {
		input, textarea {
			border: none !important;
		}
	}

	.border-on-hover {

		input:not(:hover):not(:focus), textarea:not(:hover) {
			border: none !important;
			padding-bottom: 1px;
			//border-color: #00FF00 !important;

		}

		input:hover, textarea:hover {
			//border: inherit;
		}
	}

}

.qwoach-form .qw-input-root.qw-special.qw-input {
	.el-textarea {
		vertical-align: middle;
		padding-bottom: 5px;
	}

	.el-textarea__inner {
		margin-top: 0;
		padding-top: 5px;
		padding-bottom: 0;
	}
}

</style>
